import React from 'react';
import { block } from '../../../utils/cn';
import { Popup } from '../../../Popup';
import { List } from '../../../List';
import { getPopupItemHeight, getPopupHeight, getPopupMinWidth, getPopupVerticalOffset, } from '../../utils';
import { BORDER_WIDTH, LIST_CLASSNAME } from '../../constants';
import { GroupLabel } from './GroupLabel';
import { OptionWrap } from './OptionWrap';
import './SelectPopup.css';
const b = block('select-popup');
const VIRTUALIZE_THRESHOLD = 50;
export const SelectPopup = React.forwardRef((props, ref) => {
    const { onOptionClick, setActive, renderOption, getOptionHeight, size, flattenOptions, value, popupWidth, controlRect, active, multiple, controlRef, } = props;
    const popupHeight = getPopupHeight({
        options: flattenOptions,
        getOptionHeight,
        size,
    });
    const popupVerticalOffset = getPopupVerticalOffset({ popupHeight, controlRect });
    const virtualizeEnabled = flattenOptions.length >= VIRTUALIZE_THRESHOLD;
    const inlineStyles = {
        minWidth: getPopupMinWidth(virtualizeEnabled, controlRect),
        width: popupWidth,
    };
    const handleClose = React.useCallback(() => setActive(false), [setActive]);
    const getItemHeight = React.useCallback((option, index) => {
        return getPopupItemHeight({ getOptionHeight, size, option, index });
    }, [getOptionHeight, size]);
    const renderItem = React.useCallback((option) => {
        if ('label' in option) {
            return React.createElement(GroupLabel, { label: option.label });
        }
        return (React.createElement(OptionWrap, { option: option, value: value, multiple: multiple, renderOption: renderOption }));
    }, [renderOption, value, multiple]);
    return (React.createElement(Popup, { className: b({ size, multiple }), style: inlineStyles, open: active, anchorRef: controlRef, offset: [BORDER_WIDTH, popupVerticalOffset], placement: ['bottom-start', 'top-start'], onClose: handleClose },
        React.createElement("div", { className: b('container') },
            React.createElement(List, { ref: ref, className: LIST_CLASSNAME, itemClassName: b('item'), itemHeight: getItemHeight, itemsHeight: virtualizeEnabled ? popupHeight : undefined, items: flattenOptions, filterable: false, virtualized: virtualizeEnabled, renderItem: renderItem, onItemClick: onOptionClick }))));
});
SelectPopup.displayName = 'SelectPopup';
